import styled from "styled-components";
import { SP_BREAKPOINT } from "../../../constants/app";
import { usePasskeySetting } from "./hook";

export const PasskeySettingPage: React.FC = () => {
  const {} = usePasskeySetting();

  return (
    <>
      <StyledTitle>利用中の端末で</StyledTitle>
      <StyledTitle>FIDO2の設定を行う</StyledTitle>

      <StyledSubTitle>（パスキー設定）</StyledSubTitle>
    </>
  );
};

const StyledTitle = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    font-size: 20px;
  }

  font-size: 32px;
  font-weight: 400;
  line-height: 170%;
  text-align: center;
  word-wrap: break-word;
  white-space: pre-line;
`;

const StyledSubTitle = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    font-size: 14px;
  }

  font-size: 24px;
  font-weight: 400;
  line-height: 170%;
  margin-top: 32px;
`;
